import React from 'react';

import styles from './ErrorBanner.module.css';

export type ErrorBannerAlign = 'start' | 'center';
export type ErrorBannerVariant = 'page' | 'inline';

interface ErrorBannerProps {
  title?: string;
  message: string;
  details?: string;
  onRetry?: () => void;
  retryLabel?: string;
  align?: ErrorBannerAlign;
  variant?: ErrorBannerVariant;
  children?: React.ReactNode;
}

const AlertIcon = () => (
  <svg viewBox="0 0 24 24" role="img" aria-hidden focusable="false">
    <path d="M12 2 1 21h22ZM12 9v4m0 4h.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function ErrorBanner({
  title = 'Something went wrong',
  message,
  details,
  onRetry,
  retryLabel,
  align = 'start',
  variant = 'page',
  children,
}: ErrorBannerProps) {
  const className = [
    styles.banner,
    variant === 'inline' ? styles.inline : styles.page,
    align === 'center' ? styles.alignCenter : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className} role="alert">
      <div className={styles.iconWrapper} aria-hidden>
        <AlertIcon />
      </div>
      <div className={styles.body}>
        <p className={styles.title}>{title}</p>
        <p className={styles.message}>{message}</p>
        {details && <p className={styles.details}>{details}</p>}
        {children}
        {onRetry && (
          <div className={styles.actions}>
            <button type="button" className={styles.retryButton} onClick={onRetry}>
              {retryLabel || 'Try again'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
